import { render, staticRenderFns } from "./ChangeDeviceModelsCategory.vue?vue&type=template&id=0c9ca70d"
import script from "./ChangeDeviceModelsCategory.vue?vue&type=script&lang=ts"
export * from "./ChangeDeviceModelsCategory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports